import { object, mixed, string } from "yup";

export const invoiceValidation = object({
  invoice_date: mixed().required("Invoice Date is required"),
  customer_id: string().required("Customer is required"),
});
